import { render } from "./fleet.cattle.io.bundle.vue?vue&type=template&id=1afaedc0&scoped=true"
import script from "./fleet.cattle.io.bundle.vue?vue&type=script&lang=js"
export * from "./fleet.cattle.io.bundle.vue?vue&type=script&lang=js"

import "./fleet.cattle.io.bundle.vue?vue&type=style&index=0&id=1afaedc0&lang=scss&scoped=true"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afaedc0"]])

export default __exports__